module.exports = __webpack_public_path__ + "static/media/kaptur.3ec17603.png";